export default __webpack_public_path__ + "static/char-s-45-zh-Hans-c0f85c885578795ccc7041adbc919674.webp";